import { create } from 'zustand';

export interface TabItem {
  key: string;      // unique identifier
  path: string;     // navigate target
  label: string;
  closable: boolean;
  lastActiveAt?: number; // timestamp of last activation
}

interface TabState {
  tabs: TabItem[];
  activeKey: string;
  pluginFullscreen: boolean;
  addTab: (tab: TabItem) => void;
  removeTab: (key: string) => void;
  closeOthers: (key: string) => void;
  closeLeft: (key: string) => void;
  closeRight: (key: string) => void;
  setActive: (key: string) => void;
  setPluginFullscreen: (v: boolean) => void;
}

export const useTabStore = create<TabState>((set, get) => ({
  tabs: [{ key: '/dashboard', path: '/dashboard', label: '仪表盘', closable: false, lastActiveAt: Date.now() }],
  activeKey: '/dashboard',
  pluginFullscreen: false,

  addTab: (tab) => {
    const { tabs } = get();
    const existing = tabs.find((t) => t.key === tab.key);
    if (existing) {
      // Only update if label changed; avoid unnecessary setState that causes render loops
      if (existing.label !== tab.label) {
        set({ tabs: tabs.map((t) => t.key === tab.key ? { ...t, label: tab.label } : t), activeKey: tab.key });
      } else {
        set({ activeKey: tab.key });
      }
    } else {
      set({ tabs: [...tabs, { ...tab, lastActiveAt: Date.now() }], activeKey: tab.key });
    }
  },

  removeTab: (key) => {
    const { tabs, activeKey } = get();
    const idx = tabs.findIndex((t) => t.key === key);
    const next = tabs.filter((t) => t.key !== key);
    let nextActive = activeKey;
    if (activeKey === key) {
      nextActive = next[Math.max(0, idx - 1)].key;
    }
    set({ tabs: next, activeKey: nextActive });
  },

  closeOthers: (key) => {
    const { tabs } = get();
    set({ tabs: tabs.filter((t) => !t.closable || t.key === key), activeKey: key });
  },

  closeLeft: (key) => {
    const { tabs, activeKey } = get();
    const idx = tabs.findIndex((t) => t.key === key);
    const next = tabs.filter((t, i) => i >= idx || !t.closable);
    const activeStill = next.find((t) => t.key === activeKey);
    set({ tabs: next, activeKey: activeStill ? activeKey : key });
  },

  closeRight: (key) => {
    const { tabs, activeKey } = get();
    const idx = tabs.findIndex((t) => t.key === key);
    const next = tabs.filter((t, i) => i <= idx || !t.closable);
    const activeStill = next.find((t) => t.key === activeKey);
    set({ tabs: next, activeKey: activeStill ? activeKey : key });
  },

  setActive: (key) => {
    const { tabs } = get();
    set({ tabs: tabs.map((t) => t.key === key ? { ...t, lastActiveAt: Date.now() } : t), activeKey: key });
  },
  setPluginFullscreen: (v) => set({ pluginFullscreen: v }),
}));
